import { type MCPServerInfo } from '../../types';

const ServicenowRemoteServer: MCPServerInfo = {
  serverId: 'SERVICENOW_REMOTE',
  name: 'ServiceNow (Remote)',
  slug: 'servicenow-remote',
  description:
    'ServiceNow remote MCP server powered by the ServiceNow AI Platform Manager. Exposes Now Assist Skills as tools for incident management, change management, knowledge search, catalog operations, and more.',
  source: {
    sourceType: 'DYNAMIC_REMOTE_URL',
    mcpServerUrl: 'https://{serviceNowInstanceUrl}/api/sn_mcp/mcp',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: ['serviceNowInstanceUrl'],
    properties: {
      serviceNowInstanceUrl: {
        type: 'string',
        description:
          'ServiceNow instance hostname (e.g. your-company.service-now.com)',
        sensitive: false,
        isUrlParameter: true
      }
    }
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default ServicenowRemoteServer;
